import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import * as actions from './redux/actions'
import Menu from '@material-ui/core/Menu'
import IconButton from '@material-ui/core/IconButton'
import Avatar from '@material-ui/core/Avatar'
import sirenaIcon from '../../images/sirena.png'
import Swal from 'sweetalert2'
import * as Colors from '../../common/colors'

const CurrentLead = ({ lead }) => {
  return (
    <div
      className="current-client--container"
      title={lead.client_lead ? `ID: ${lead.client_lead.id}` : ''}
    >
      <div className="noselect small-header">
        <div className="current-client--label">Cliente activo</div>
        <div className="material-icons check-icon">check_circle</div>
      </div>
      <div className="current-client--value">
        {lead.client_lead ? `${lead.client_lead.firstName} ${lead.client_lead.lastName}` : 'Ninguno'}
      </div>
    </div>
  )
}

export class LeadsMenu extends Component {
  static propTypes = {
    lead: PropTypes.object,
    pending: PropTypes.bool,
    client_lead_cleared: PropTypes.array.isRequired,
    notifications: PropTypes.array.isRequired,
    actions: PropTypes.object.isRequired,
  }

  state = {
    anchorEl: null,
  }

  handleClose = () => {
    this.setState({ anchorEl: false })
  }

  openMenu = (event) => {
    if (!this.props.pending) {
      this.setState({ anchorEl: event.currentTarget })
    }
  }

  clearLead = () => {
    const hasLead = !!this.props.lead.client_lead
    if (hasLead) {
      this.handleClose()
      Swal.fire({
        text: 'Esta seguro de quitar el cliente actual?',
        showCancelButton: true,
        confirmButtonColor: Colors.COLOR_INFO,
        cancelButtonColor: Colors.COLOR_DANGER_DARK,
        confirmButtonText: 'Cancelar',
        cancelButtonText: 'Si, eliminar',
        allowOutsideClick: false,
      }).then((result) => {
        if (!result.value) {
          this.props.actions.clearCurrentLead()
          this.props.actions.SuccessAction({ title: `Ya no hay cliente activo` })
        }
      })
    }
  }

  setLeadWithPreviousLead = (client) => {
    const currentLeadId = this.props.lead.client_lead && this.props.lead.client_lead.id
    this.handleClose()
    this.props.actions
      .setCurrentLead({ id: client.id, lead_app: 'Sirena' })
      .then((res) => {
        if (res) {
          if (currentLeadId !== res.id) {
            const { firstName, lastName } = res
            this.props.actions.SuccessAction({ title: `Cliente ${firstName} ${lastName} cargado` })
          } else {
            const { firstName, lastName } = res
            this.props.actions.InfoAction({ title: `Cliente ${firstName} ${lastName} ya está cargado` })
          }
        }
      })
      .catch((err) => {
        console.error(err)
        this.props.actions.ErrorAction({ title: 'Error al cargar cliente de Sirena' })
      })
  }

  componentDidMount() {
    // FIXME: esto no debería quedar una vez se retrabaje la integración con sirena
    // if (!this.props.location.pathname.startsWith('/presupuestador')) {
    //   this.props.actions.clearCurrentLead()
    // }
  }

  render() {
    return (
      <React.Fragment>
        <IconButton color="inherit" onClick={this.openMenu} className="icon-sirena">
          <Avatar className={!this.props.lead.client_lead && !this.props.pending ? "icon-sirena--inactive":"icon-sirena--active"} alt="Sirena" src={sirenaIcon}/>
        </IconButton>
        <Menu
          id="LeadsMenu"
          elevation={2}
          getContentAnchorEl={null}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
          anchorEl={this.state.anchorEl}
          keepMounted
          open={Boolean(this.state.anchorEl)}
          onClose={this.handleClose}
        >
          <CurrentLead clearLead={this.clearLead} lead={this.props.lead} />
        </Menu>
      </React.Fragment>
    )
  }
}

const leadSelector = ({ client_lead, client_lead_app }) => ({
  client_lead,
  client_lead_app,
})
/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    lead: leadSelector(state.home),
    pending: state.home.setCurrentLeadPending,
    client_lead_cleared: state.home.client_lead_cleared,
    notifications: state.home.notifications,
    location: state.router.location,
  }
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(LeadsMenu)
